export default {"src":"/_next/static/media/Chevron-right-white.38da5ed1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};